import { useLoggedInForMandatee } from '@/modules/trust/hooks/useLoggedInForMandatee'
import { isIntramuros } from '@/utils/intramuros'
import { useQuestionnaireEngine } from './useQuestionnaireEngine'

/**
 * Common Mixpanel properties for events fired from within a questionnaire:
 * the questionnaire slug, mandate state and intramuros state.
 */
export const useQuestionnaireTrackingProps = () => {
  const { state } = useQuestionnaireEngine()
  const isLoggedInForMandatee = useLoggedInForMandatee()

  return {
    questionnaire_slug: state.questionnaire.name,
    is_mandate: isLoggedInForMandatee,
    is_intramuros: isIntramuros,
  }
}
